import * as R from "ramda";
import React, {Component} from "react";
import ToggleButton from "react-toggle-button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import MasterHirarkiModifying from "./MasterHirarkiModifying";
import Api from "../../../Services/Api";
import {flattenFormGroupObject, mapToSelectOption} from "../../common/mapper";
import {formGroup} from "./config";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import * as ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";

class MasterHirarki extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    
                    const viewIndex = (tableMeta.rowIndex + 1) - rowsPerPage > 0 ? tableMeta.rowIndex - rowsPerPage : tableMeta.rowIndex 
                    const rowNumber = page * rowsPerPage + (viewIndex + 1);

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "roleName",
            label: "Nama Role",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "ahasLine",
            label: "Ahass Line",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "mktLine",
            label: "Mkt Line",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "adminLine",
            label: "Adm Line",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (_, {rowIndex}) => (
                    <ToggleButton
                        value={R.equals(this.state.dataTable[rowIndex].status, "ACTIVE")}
                        onToggle={(value) => this.handleChangeStatus(rowIndex, !value)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "",
            label: "Action",
            options: {
                customBodyRender: (_, {rowIndex}) => {
                    return (
                        <div style={{width: "115px"}}>
                            {this.props.menuAccess && this.props.menuAccess.updateAccess && (
                                <SimpleButton
                                    category="action_button"
                                    style={{marginRight: 15, backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                    onClick={() => this.handleModifyingModalVisibility(rowIndex)}
                                />
                            )}

                            {this.props.menuAccess && this.props.menuAccess.deleteAccess && (
                                <SimpleButton
                                    category="action_button"
                                    style={{marginRight: 15, backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                    onClick={() => this.handleShowAlert(rowIndex)}
                                />
                            )}
                        </div>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            modifyingVisible: false,
            data: this.initialData,
            dataTable: [],
            selectedData: null,
            loading: false,
            showAlert: false,
            deleteId: null,
            confirmDeleteAlert: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        if (!R.isNil(index)) {
            this.handleTriggerLoading();
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getByIdHirarki,
                menuName: "Master Hirarki",
                setError: this.props.setError,
                args: this.state.dataTable[index].id,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                let selectedData = {
                    ...res.data.data,
                    mktLine: mapToSelectOption(res.data.data.mktLine),
                    ahasLine: mapToSelectOption(res.data.data.ahasLine),
                    adminLine: mapToSelectOption(res.data.data.adminLine),
                };
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: selectedData,
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
            this.handleTriggerLoading();
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleShowAlert = (index) => {
        let id = index === null ? null : this.state.dataTable[index].id;
        this.setState((prevValue) => ({
            ...prevValue,
            showAlert: !prevValue.showAlert,
            deleteId: id,
        }))
    };

    handleConfirmDeleteAlert = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            confirmDeleteAlert: !prevValue.confirmDeleteAlert,
        }))
    };

    handleDelete = async () => {
        this.handleTriggerLoading();
        let {deleteId} = this.state;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteHirarki,
            menuName: "Master Hirarki",
            setError: this.props.setError,
            args: deleteId,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchData();
            await this.handleShowAlert(null);
            this.handleConfirmDeleteAlert();
        }
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();

        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateHirarki,
            menuName: "Master Hirarki",
            setError: this.props.setError,
            args: data,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchData();
        }
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (data) => {
        this.handleTriggerLoading();
        let parsedData = data ? {
            ...flattenFormGroupObject(data),
            mktLine: data.mktLine.value.value,
            adminLine: data.adminLine.value.value,
            ahasLine: data.ahasLine.value.value,
        } : null;
        let api;
        if (!R.isNil(this.state.selectedData)) {
            parsedData.id = this.state.selectedData.id
            api = Api.create("NAGAMAS_MASTER_DATA").updateHirarki;
        } else {
            api = Api.create("NAGAMAS_MASTER_DATA").saveHirarki;
        }
        let res = await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Hirarki",
            setError: this.props.setError,
            args: parsedData,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            await this.fetchData();
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllHirarki,
            menuName: "Master Hirarki",
            setError: this.props.setError,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.data.length,
                }
            }));
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <Container>
                <SimpleDataTable
                    key={`${pagination.totalData}-${pagination.page}`}
                    data={this.state.dataTable}
                    columns={this.tableColumns}
                    toCount={pagination.totalData}
                    rowsPerPage={pagination.limit}
                    page={pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                    footerAdditionalButtons={
                        this.props.menuAccess && this.props.menuAccess.createAccess && (
                            <SimpleButton
                                onClick={() => this.handleModifyingModalVisibility()}
                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                text={"Tambah"}
                            />
                        )
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterHirarkiModifying
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.showAlert && (
                    <SimpleAlert
                        visible={this.state.showAlert}
                        onClickClose={() => this.handleShowAlert(null)}
                        content={"Apakah anda yakin ingin menghapus data ini?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleDelete} text={"Ya"}/>
                                <SimpleButton onClick={() => this.handleShowAlert(null)} text={"Tidak"}/>
                            </FlexView>
                        }
                    />
                )}

                {this.state.confirmDeleteAlert && (
                    <SimpleAlert
                        visible={this.state.confirmDeleteAlert}
                        onClickClose={this.handleConfirmDeleteAlert}
                        content={"Data Berhasil Dihapus"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleConfirmDeleteAlert} text={"OK"}/>
                            </FlexView>
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Container>

        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(null, mapDispatchToProps)(MasterHirarki);